import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import Header from './header';
import Footer from './footer';

/*
 * On a fresh load the browser tries to resolve #hash before React has mounted the
 * section, so it silently stays at the top. This also covers the /about and
 * /prepbox-ai redirects, which both land on a hash.
 */
const ScrollToHash = () => {
    const { hash } = useLocation();

    useEffect(() => {
        if (!hash) {
            window.scrollTo(0, 0);
            return undefined;
        }

        let done = false;
        const go = () => {
            if (done) return;
            const target = document.querySelector(hash);
            if (!target) return;
            done = true;
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        };

        /* Webfont loading shifts every section offset, so scrolling before the
           webfonts settle lands in the wrong place. Wait for them where supported,
           with a timeout fallback so the scroll still happens if they never do. */
        const timer = window.setTimeout(go, 300);
        if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(go).catch(() => {});
        }

        return () => {
            done = true;
            window.clearTimeout(timer);
        };
    }, [hash]);

    return null;
};

const Layout = () => {
    return (
        <>
            <ScrollToHash />
            <Header />
            <main className="main">
                <Outlet />
            </main>
            <Footer />
        </>
    );
};

export default Layout;
